import { fetchConToken } from '../../helpers/fetch';

export const getClientes = async (contadorId = null) => {
    const url = contadorId
        ? `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/dashboard/clientes?id_contador=${contadorId}`
        : `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/dashboard/clientes`;

    try {
        const resp = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'x-token': localStorage.getItem('token')
            },
        });

        const respuesta = await resp.json();

        if (resp.ok) {
            return respuesta.clientes;
        } else {
            console.log('Error al cargar clientes:', respuesta);
            return [];
        }
    } catch (error) {
        console.log('Error fetching clientes:', error);
        return [];
    }
};

export const onEditarCliente = (id, razon_social, nit, div, telefono, nombre_representante, gran_contribuyente, comentarios, estado) => {
    return async (dispatch) => {
        try {
            const body = {
                razon_social,
                nit,
                div,
                telefono,
                nombre_representante,
                gran_contribuyente,
                comentarios,
                estado
            };

            const resp = await fetchConToken(
                `/api/dashboard/clientes/${id}`,
                body,
                'PUT'
            );

            const respuesta = await resp.json();
            return respuesta;
        } catch (error) {
            console.log('Error en onEditarCliente:', error);
            return {
                msg: 'Error al actualizar cliente'
            };
        }
    };
};
